module.exports = "/images/vendor/flag-icon-css/flags/4x3/fr.svg?b1156355de9691d768df19a8a2b44da4";